import { getUserInfo, logout, register, loginByPassword, loginBySmsCode } from '@/api/login';
import { getToken, removeToken, removeTokenOld, setToken, getSubdomain } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import { clearCookie } from '@/utils/cookie';
import Cookies from 'js-cookie';
import { getPubKey } from '@/api/common';
import JSEncrypt from 'jsencrypt';
import { setShippersUserInfo } from '@/utils/shippers';

const state = {
  token: getToken(),
  name: '',
  groupName: '',
  groupIconUrl: '',
  groupId: '',
  mobile: '',
  introduction: '',
  userInfo: {},
  roles: [],
  roleCode: '',
  changePassword: '',
};
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_GROUP_NAME: (state, groupName) => {
    state.groupName = groupName;
  },
  SET_GROUP_ID: (state, groupId) => {
    state.groupId = groupId;
  },
  SET_GROUP_ICON: (state, groupIconUrl) => {
    state.groupIconUrl = groupIconUrl;
  },
  SET_MOBILE: (state, mobile) => {
    state.mobile = mobile;
  },
  SET_CHANGEPASSWORD: (state, changePassword) => {
    state.changePassword = changePassword;
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
    if (userInfo) {
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }
  },
  SET_ROLES: (state, role) => {
    if (role) {
      state.roles = role;
    } else {
      state.roles = [];
    }
    state.roleCode = role;
  },
};
const actions = {
  // user login
  login({ commit }, userInfo) {
    const { mobile, password, code, type } = userInfo;
    return new Promise(async (resolve, reject) => {
      if (type === 'first') {
        var rsaPassWord = '';
        var pubKeyId = '';
        // 对内容进行加密
        const encryptor = new JSEncrypt(); // 创建加密对象实例
        const { code, data } = await getPubKey();
        if (code == 200) {
          pubKeyId = data.pubKeyId;
          encryptor.setPublicKey(data.pubKey);
          rsaPassWord = encryptor.encrypt(password);
        }
        loginByPassword({
          mobile: mobile,
          password: rsaPassWord,
          pubKeyId: pubKeyId,
        })
          .then(response => {
            const { data } = response;
            commit('SET_USERINFO', data);
            commit('SET_TOKEN', data.token);
            commit('SET_ROLES', data.roleIdList);
            commit('SET_NAME', data.name);
            commit('SET_GROUP_NAME', data.groupName);
            commit('SET_GROUP_ID', data.groupId);
            commit('SET_GROUP_ICON', data.groupIconUrl);
            commit('SET_MOBILE', data.mobile);
            setShippersUserInfo({
              accessToken: data.token,
              userName: data.name,
              phoneNo: data.mobile,
              userId: data.userId,
            });
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      }
      if (type === 'second') {
        loginBySmsCode({
          mobile: mobile,
          code: code,
        })
          .then(response => {
            const { data } = response;
            setShippersUserInfo({
              accessToken: data.token,
              userName: data.name,
              phoneNo: data.mobile,
              userId: data.userId,
            });
            commit('SET_USERINFO', data);
            commit('SET_TOKEN', data.token);
            commit('SET_ROLES', data.roleIdList);
            commit('SET_NAME', data.name);
            commit('SET_GROUP_NAME', data.groupName);
            commit('SET_GROUP_ID', data.groupId);
            commit('SET_GROUP_ICON', data.groupIconUrl);
            commit('SET_MOBILE', data.mobile);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  },
  register({ commit }, userInfo) {
    const { type } = userInfo;
    return new Promise((resolve, reject) => {
      if (type === 'second') {
        register(userInfo)
          .then(response => {
            const { data } = response;
            // commit('SET_USERINFO', data);
            commit('SET_TOKEN', data.token);
            // commit('SET_ROLES', data.roleIdList);
            commit('SET_NAME', data.name);
            commit('SET_GROUP_NAME', data.groups[0].name);
            commit('SET_GROUP_ID', data.groups[0].uid);
            // commit('SET_GROUP_ICON', data.groupIconUrl);
            commit('SET_MOBILE', data.mobile);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfo()
        .then(response => {
          const { data } = response;
          if (!data) {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('Verification failed, please Login again.');
          }
          commit('SET_USERINFO', data);
          commit('SET_ROLES', data.roleIdList);
          commit('SET_NAME', data.name);
          commit('SET_GROUP_NAME', `${data.groupName}`);
          commit('SET_GROUP_ID', data.groupId);
          commit('SET_GROUP_ICON', data.groupIconUrl);
          commit('SET_MOBILE', data.mobile);
          // roles must be a non-empty array
          if (!data.roleIdList) {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('getInfo: roles must be a non-null array!');
          }
          resolve(state);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(res => {
          if (res.code == 200) {
            clearCookie();
          }
          commit('SET_TOKEN', '');
          commit('SET_ROLES', '');
          commit('SET_USERINFO', '');
          commit('SET_GROUP_NAME', '');
          commit('SET_GROUP_ID', '');
          commit('SET_GROUP_ICON', '');
          removeToken();
          removeTokenOld();
          const subdomain = getSubdomain(window.location.hostname);
          Cookies.remove('ShippersUserInfo', { domain: subdomain });
          Cookies.remove('unified-token', { domain: subdomain });
          Cookies.remove('oss-token', { domain: subdomain });
          Cookies.remove('satoken', { domain: subdomain });
          Cookies.remove('ShippersUserInfo');
          Cookies.remove('unified-token');
          // resetRouter();
          window.location.href = '/login';
          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          dispatch('tagsView/delAllViews', null, { root: true });

          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', '');
      removeToken();
      removeTokenOld();
      Cookies.remove('groupId');
      resolve();
    });
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = `${role}-token`;
    commit('SET_TOKEN', token);
    setToken(token);
    const { roles } = await dispatch('getInfo');
    resetRouter();
    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true });
    // dynamically add accessible routes
    router.addRoutes(accessRoutes);

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
